import { computed, ref } from 'vue';
import { storeToRefs } from 'pinia';
import type { FieldInitialSettings, FieldSchema, RawField } from '@FormModule';
import type { GenericField } from '@Types';
import { getShelterNow } from '@Constants';
import { useSessionStore } from '@Stores';
import { useForm } from '@FormModule';

const fieldsSchema = ref<FieldSchema[]>([]);

export default function () {
  const { shelterProfile, userProfile } = storeToRefs(useSessionStore());
  const { getDetailsSchema } = useForm();

  const currentSchemaModels = ref<Set<GenericField>>(new Set());
  const fieldsSettings: FieldInitialSettings = {
    outcome_date: {
      model: getShelterNow(),
      settings: {
        minDate: getShelterNow(),
        showTime: true,
        withTime: true,
      },
    },
  };

  const rawFields = ref<RawField[]>([
    {
      label: 'Outcome Date',
      name: 'outcome_date',
      required: true,
      type: 'date',
      value: '',
    },
  ]);

  const userCanSetPaidDate = computed(
    () =>
      shelterProfile.value?.can_update_payment_at_cart &&
      shelterProfile.value?.can_update_payment_at_cart.includes(userProfile.value?._id)
  );
  // TODO :: AF-587 We need to have a outcome_date per animal and not per outcome
  function setForm(minOutcomeDate?: Date | null) {
    fieldsSettings!.outcome_date!.settings!.minDate = minOutcomeDate ? new Date(minOutcomeDate) : null;

    if (userCanSetPaidDate.value) {
      setPaidDateField();
    }

    fieldsSchema.value = getDetailsSchema(rawFields.value, fieldsSettings);
  }

  function setPaidDateField() {
    rawFields.value.push({
      label: 'Paid Date',
      name: 'paid_date',
      required: false,
      type: 'date',
      value: null,
    });

    fieldsSettings.paid_date = {
      model: null,
      settings: {
        noModelOnStart: true,
      },
    };
  }

  return {
    currentSchemaModels,
    fieldsSchema,
    rawFields,
    userCanSetPaidDate,
    setForm,
  };
}
